import React, { useState } from 'react';
import { TRANSITION_TYPE } from '../../constants/editorConst';
import Icon from '../Icon/Icon';
import styles from './TransitionChooser.module.scss';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import RadioButton from '../RadioButton/RadioButton';

const TransitionChooser = ({ active = 1, onClicked, className, mini }) => {
  const { t } = useTranslation();

  const [transitionOptions] = useState([
    { type: TRANSITION_TYPE.DIP_TO_WHITE, title: t('account.settings.preferences.clip_transitions.dip_to_white') },
    { type: TRANSITION_TYPE.DIP_TO_BLACK, title: t('account.settings.preferences.clip_transitions.dip_to_black') },
  ]);

  return (
    <ul className={cx(styles.wrapper, className, { [styles.miniContainer]: mini })}>
      {transitionOptions.map(transition => (
        <li key={transition.type} className={styles.transitionItem}>
          <div className={styles.iconTitleContainer}>
            <Icon
              src="transition"
              className={cx(styles.transitionIcon, {
                [styles.toBackIcon]: transition.type === TRANSITION_TYPE.DIP_TO_BLACK,
              })}
            />
            <span className={styles.label}>{transition.title}</span>
          </div>
          <RadioButton
            type="radiobutton"
            checked={active === transition.type}
            id={transition.title}
            variant="secondary"
            onChange={() => onClicked(transition.type)}
            className={styles.radioButton}
            size="medium"
          />
        </li>
      ))}
    </ul>
  );
};

export default TransitionChooser;
